(function () {
  angular.module("akitabox.ui.dialogs.recommission", [
    "ngMaterial",
    "akitabox.core.services.helpers",
    "akitabox.core.services.organization",
  ]);
})();
